import { FooterBottomData } from '../../../Admin/Footer-Bottom/store/footerBottomSlice';
import { cashApi } from '../../../template/SideNav/sideNavSlice';

export interface FooterLinks {
  id?: number;
  title_en?: string;
  title_bn?: string;
  url?: string;
  order?: number;
  is_active?: boolean;
}

interface FooterLinkProps {
  results: FooterLinks[];
}

const FooterLinksApi = cashApi
  .enhanceEndpoints({ addTagTypes: ['footerLinks', 'footerBottom'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getFooterLink: builder.query<FooterLinkProps, void>({
        query: () => {
          return `v1/web-contents/current-footer-links/?limit=1000`;
        },
        providesTags: ['footerLinks'],
      }),
      getDashboardFooterBottom: builder.query<FooterBottomData, void>({
        query: () => {
          return `v1/web-contents/current-footer-bottoms/`;
        },
        providesTags: ['footerBottom'],
      }),
    }),
  });

export const { useGetFooterLinkQuery, useGetDashboardFooterBottomQuery } =
  FooterLinksApi;
